import React from 'react';

// Inline SVG glyphs, as path data.
//
// One file rather than one component each: these are single paths on a shared
// 16×16 grid, so menus share the same icons.
//
// `currentColor` throughout, so a glyph takes the colour of the text it sits
// beside and a disabled menu item greys its icon without being told to.

export const ICONS = {
  pencil: 'M11.2 2.8a1.7 1.7 0 0 1 2.4 2.4L5.9 12.9l-3.2.8.8-3.2 7.7-7.7Z',
  trash: 'M2.8 4.3h10.4M6.3 4.3V3a.9.9 0 0 1 .9-.9h1.6a.9.9 0 0 1 .9.9v1.3M4.2 4.3l.6 8.4a1 1 0 0 0 1 .9h4.4a1 1 0 0 0 1-.9l.6-8.4',
  gear: 'M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm5.5-2c0 .4 0 .7-.1 1l1.3 1-1.3 2.2-1.5-.5a5 5 0 0 1-1.7 1L9.9 14H7.3l-.3-1.4a5 5 0 0 1-1.7-1l-1.5.5L2.5 10l1.3-1a5.4 5.4 0 0 1 0-2l-1.3-1 1.3-2.2 1.5.5a5 5 0 0 1 1.7-1L7.3 2h2.6l.3 1.4c.6.2 1.2.6 1.7 1l1.5-.5L14.7 6l-1.3 1c.1.3.1.6.1 1Z',
  upload: 'M8 10.5V2.8M5.2 5.6 8 2.8l2.8 2.8M2.8 10.5v1.8a1 1 0 0 0 1 1h8.4a1 1 0 0 0 1-1v-1.8',
  eye: 'M1.5 8S3.9 3.5 8 3.5 14.5 8 14.5 8 12.1 12.5 8 12.5 1.5 8 1.5 8Z M8 9.9a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8Z',
  eyeOff: 'M6.5 4a5.9 5.9 0 0 1 1.5-.2c4.1 0 6.5 4.2 6.5 4.2a11 11 0 0 1-1.9 2.3M4 4.9A11 11 0 0 0 1.5 8S3.9 12.2 8 12.2c.9 0 1.7-.2 2.4-.5M2 2l12 12',
  paperclip: 'M10.6 6.1 6.2 10.5a1.6 1.6 0 0 0 2.3 2.3l4.8-4.8a2.9 2.9 0 0 0-4.1-4.1L4.2 8.9a4.2 4.2 0 0 0 6 6l4-4',
  tag: 'M2.5 7.3V3a.5.5 0 0 1 .5-.5h4.3c.1 0 .3 0 .4.2l6 6a.5.5 0 0 1 0 .7l-4.3 4.3a.5.5 0 0 1-.7 0l-6-6a.5.5 0 0 1-.2-.4ZM5.3 5.3h.01',
  back: 'M9.5 3.5L5 8l4.5 4.5M5 8h7',
  close: 'M3.5 3.5l8 8M11.5 3.5l-8 8',
  calendar: 'M3 4.2h10a.5.5 0 0 1 .5.5v8.3a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4.7a.5.5 0 0 1 .5-.5ZM2.5 7h11M5.5 2.7v2.6M10.5 2.7v2.6',
};

export default function Icon({ name, size = 14, ...rest }) {
  const d = ICONS[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
      {...rest}
    >
      <path d={d} stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
